<template>
  <div>
    <top>
      <Icon slot="left" type="ios-arrow-back" @click="back" />
      <p slot="center">里程分析</p
    ></top>
    <month ref="month"></month>
  </div>
</template>
<script>
import month from "./month.vue";
export default {
  components: {
    month,
  },
  data() {
    return {
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/home" });
    },
  },
  mounted() {
    //this.$refs.month.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/fenxi/licheng/index.vue